const state = {
  wordData: {},
  wordActive: false,
};

const mutations = {
  CHANGE_WORD_CONTENT(state, wordObj) {
    state.wordData = wordObj;
  },
  CHANGE_WORD_ACTIVE(state, wordActive) {
    state.wordActive = wordActive;
  },
};

const actions = {
  someAsyncTask({ commit }) {
    // do something async
    commit('TEST');
  },
};

const getters = {
  wordData: (state) => {
    return state.wordData;
  },
  wordActive: (state) => {
    return state.wordActive;
  },
};
export default {
  state,
  mutations,
  actions,
  getters,
};
